import React from 'react';
import classnames from 'classnames';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import classes from '../single-view-design-upload.scss';
export const SingleViewAdditionalDesignUploadButton = ({
  view,
  inputId,
  isLimitedEdition,
  onUploadClick
}) => {
  return /*#__PURE__*/React.createElement("label", {
    onClick: onUploadClick,
    htmlFor: inputId,
    className: classnames(classes.additionalLogo, {
      [classes.orangeLabel]: isLimitedEdition
    }),
    tabIndex: 0,
    onKeyDown: e => handleOnEnterPressed(e, onUploadClick)
  }, "Additional ", view.name, " image");
};